import React from 'react';
import Box from '@mui/material/Box';

const shimmerStyle = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%)',
  backgroundSize: '400% 100%',
  animation: 'shimmer 1.2s ease-in-out infinite',
};

const AdListShimmer = ({ count = 8 }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', direction: 'rtl', py: 2, px: 2, justifyContent: { xs: 'center', md: 'flex-start' }, columnGap: { xs: 0, sm: 0, md: '24px' } }}>
    {[...Array(count)].map((_, idx) => (
      <Box
        key={idx}
        sx={{
          flex: { xs: '0 0 100%', sm: '0 0 50%', md: '0 0 calc((100% - 72px) / 4)' },
          maxWidth: { xs: '90vw', sm: '50%', md: 'calc((100% - 72px) / 4)' },
          mx: { xs: 'auto', sm: 0, md: 0 },
          mb: { xs: 1.5, sm: 2, md: 3 },
          position: 'relative',
        }}
      >
        <Box sx={{ borderRadius: 3, boxShadow: 3, p: 2, bgcolor: 'grey.100', minHeight: 320, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ height: 192, borderRadius: 2, mb: 2, ...shimmerStyle }} />
          <Box sx={{ height: 24, width: '60%', borderRadius: 1, mb: 1, ...shimmerStyle }} />
          <Box sx={{ height: 18, width: '80%', borderRadius: 1, mb: 1, ...shimmerStyle }} />
          <Box sx={{ height: 18, width: '40%', borderRadius: 1, mb: 1, ...shimmerStyle }} />
        </Box>
      </Box>
    ))}
    <style>{`
      @keyframes shimmer {
        0% { background-position: -400px 0; }
        100% { background-position: 400px 0; }
      }
    `}</style>
  </Box>
);

export default AdListShimmer;
